// ============================================
// Audit Logging Utility
// Fire-and-forget helper for logging user/system
// actions to the dataops_audit_log collection.
// ============================================

import type { AuditAction } from '../types/dataops';
import { saveAuditEntry } from '../services/firestore/dataopsService';
import { getSessionId } from './sessionId';

/** Log an audit event. Fire-and-forget — errors are caught silently. */
export function logAudit(
  action: AuditAction,
  resource: string,
  details: Record<string, string | number | boolean> = {},
): void {
  const id = `audit-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

  saveAuditEntry({
    id,
    timestamp: new Date().toISOString(),
    actor: getSessionId(),
    action,
    resource,
    details,
    ipAddress: null,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
    result: 'success',
  }).catch(() => {
    // Silent failure — audit logging should never block user flow
  });
}
